/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/no-danger */
import { Tooltip } from 'antd';
import * as DOMPurify from 'dompurify';
import React from 'react';
import { RichTextEditor } from 'components/atoms/rich-text-editor/rich-text-editor';
import ckeStyles from 'components/organisms/templates/commons/cke.module.css';

interface TaskNameProps {
  taskName: string;
  dataCy?: string;
  className?: string;
  style?: React.CSSProperties;
}

interface PhaseNameProps {
  phaseName: string;
}

export const TaskName = ({
  taskName,
  dataCy,
  className,
  style,
}: TaskNameProps) => {
  return (
    <Tooltip
      destroyTooltipOnHide
      placement="topLeft"
      title={
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(taskName),
          }}
        />
      }
    >
      <div
        data-cy={dataCy}
        style={style}
        className={`project-template-task ${className ?? ''}`}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(taskName),
        }}
      />
    </Tooltip>
  );
};

export const PhaseName = ({ phaseName }: PhaseNameProps) => {
  const content = (
    <div
      className="project-template-task"
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(phaseName),
      }}
    />
  );

  return (
    <Tooltip placement="topLeft" title={content} destroyTooltipOnHide>
      {content}
    </Tooltip>
  );
};

export const TemplateImportNameField = ({ name }: { name: string }) => {
  return (
    <RichTextEditor
      className={`${ckeStyles['template-title-input']}  ${ckeStyles['template-list-view']} ${ckeStyles['template-import-name-field']}`}
      data={name}
      readonly
      allowSimpleVariables
      disallowNewLine
    />
  );
};

export const ShiftDaysNameField = TemplateImportNameField;
